import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState, useDebounce } from "@miplatform/hooks";
import {
  CalendarEventType,
  ICalendarWorkTemplateBase,
  IUserListItemResponse,
} from "@miplatform/types";
import { buildSearchQuery, getGUIDArray } from "@miplatform/utils";

export const useCalendarAttemptSearchViewModel = ({
  eventType,
  workTemplateBases,
  assigneeModeUser,
}: {
  eventType: CalendarEventType;
  workTemplateBases: ICalendarWorkTemplateBase[];
  assigneeModeUser?: IUserListItemResponse | null;
}) => {
  const [attempts, setAttempts] = useState([]);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search);

  const stateManager = useComponentState();

  const getAttempts = () => {
    stateManager.run(async () => {
      const searchQuery = buildSearchQuery(debouncedSearch, [
        "home.address.addressLine1",
      ]);
      const getAttempts =
        eventType === CalendarEventType.WorkOrder
          ? taskService.attempts.getAllWorkOrders
          : taskService.attempts.getAll;

      const { status, data } = await getAttempts({
        filters: {
          ...(assigneeModeUser?.id && {
            assignedUserId: { type: "guid", value: assigneeModeUser.id },
          }),
          assignment: {
            [eventType]: {
              [`${eventType}TemplateId`]: {
                in: getGUIDArray(workTemplateBases.map(({ id }) => id)),
              },
            },
          },
          ...searchQuery,
        },
        sort: "scheduledStartDate desc",
        top: 25,
      });

      if (status === HTTP_STATUSES.OK) {
        setAttempts(data);
      }
    });
  };

  return {
    attempts,
    search,
    debouncedSearch,
    isLoading: stateManager.isBusy(),
    setSearch,
    getAttempts,
  };
};
